import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { Button, Row } from "@masterteam/mt-design-react";

import Table from "../../NewTable";
import StakeholderForm from "./StakeholderForm";
import { getLookupName } from "../../../helpers";

import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";

import "./style.scss";

const initialModalState = {
  isOpen: false,
  data: null,
};

const Stakeholders = ({ lists, isReadOnly }) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  const { values, setFieldValue } = useFormikContext();
  const [formModal, setFormModal] = useState(initialModalState);
  const [stakeholders, setStakeholders] = useState(values.Stakeholders);

  const StakeholderClassification = useSelector(
    ({ theme }) => theme.StakeholderClassification.item.Items
  );
  const columns = [
    {
      key: "Name",
      cell: (item) => item?.StakeholderName,
      header: intl.formatMessage({
        id: "initiative.stakeholder-name",
      }),
      width: "50%",
    },
    {
      key: "Classification",
      cell: (item) =>
        getLookupName(
          StakeholderClassification,
          `${item?.Classification}`,
          isAr
        ),
      header: intl.formatMessage({
        id: "initiative.classification",
      }),
      width: "50%",
    },
  ];

  const actions = [
    {
      key: "edit",
      variant: "primary",
      Icon: EditIcon,
      "tooltip-position": "buttom",
      tooltip: "Update",
      onClick: (item) => {
        setFormModal({ isOpen: true, data: item });
      },
    },
    {
      key: "delete",
      variant: "error",
      Icon: DeleteIcon,
      "tooltip-position": "buttom",
      tooltip: "Delete",
      onClick: (item) => {
        setStakeholders(stakeholders.filter((e) => e.ID !== item.ID));
      },
    },
  ];

  useEffect(() => {
    setFieldValue("Stakeholders", stakeholders);
  }, [stakeholders]);

  return (
    <div className="stakeholders">
      <Row align="center" justify="between">
        <div className="title-wrapper">
          {intl.formatMessage({
            id: "initiative.stakeholders",
          })}
        </div>

        {!isReadOnly && (
          <Button
            shape="round"
            onClick={() => setFormModal({ isOpen: true, data: null })}
          >
            {intl.formatMessage({ id: "common.add" })}
          </Button>
        )}
      </Row>
      <Table
        data={stakeholders}
        columns={columns}
        actions={isReadOnly ? [] : actions}
        headerHasBackgroundColor
      />

      {formModal.isOpen && (
        <StakeholderForm
          data={formModal.data}
          stakeholders={stakeholders}
          setStakeholders={setStakeholders}
          closeModal={() => setFormModal(initialModalState)}
          lists={lists}
        />
      )}
    </div>
  );
};

export default Stakeholders;
